import commonConfig from '@eats/common/config/common'
import type {ProxySettingsDataType} from '@eats/common/types'

const PUBLIC_PATH = '/s3/eda-front/www/assets/'

export const withCustomProtocol = (url: string, buildAssetsProtocol?: string | null) => {
  if (buildAssetsProtocol) {
    return url.replace(/^https:\/\//, buildAssetsProtocol)
  }
  return url
}

export const applyBuildAssetsProtocolToManifest = (
  manifest: Record<string, string>,
  buildAssetsProtocol?: string | null,
): Record<string, string> => {
  if (!buildAssetsProtocol) {
    return manifest
  }

  return Object.fromEntries(
    Object.entries(manifest).map(([key, url]) => [key, withCustomProtocol(url, buildAssetsProtocol)]),
  )
}

export const applyBuildAssetsProtocolToUrls = (urls: string[], buildAssetsProtocol?: string | null): string[] => {
  if (!buildAssetsProtocol) {
    return urls
  }

  return urls.map((url) => withCustomProtocol(url, buildAssetsProtocol))
}

export const defineRemotePublicPath = (
  platform = '',
  proxySettingsData: ProxySettingsDataType | undefined = undefined,
) => {
  if (process.env.NODE_ENV === 'development' || process.env.EDA_WEB_IS_AUTOTEST === 'true') {
    return `/${__BUILD_ID__}/`
  }

  if (proxySettingsData) {
    const url = new URL(`https://static.yandexcom.net${PUBLIC_PATH}${__BUILD_ID__}/`)

    // перезаписать урл из конфига при его наличии
    proxySettingsData.proxy?.some(({fromUrl, toUrl}) => {
      if (toUrl && fromUrl) {
        if (fromUrl.startsWith('https://yastatic.net')) {
          const target = new URL(toUrl)
          url.hostname = target.hostname
          if (target.pathname !== '/') {
            url.pathname = target.pathname + url.pathname.slice(1)
          }
          return true
        }
      }
      return false
    })

    return url.toString()
  }

  const configPublicPath = commonConfig.publicPath
  if (configPublicPath) {
    return `${configPublicPath}${__BUILD_ID__}/`
  }

  const isCfEnabled = commonConfig.cdn?.cloudflareEnabledPlatforms?.includes(platform)

  if (isCfEnabled) {
    return `https://yastatic.yangostatic.net${PUBLIC_PATH}${__BUILD_ID__}/`
  }
  return `https://yastatic.net${PUBLIC_PATH}${__BUILD_ID__}/`
}
